import { PromptImage } from "@/features/multi-format/question-form/state";
import { QuestionFieldInput, QuestionType } from "@/generated/graphql";

export type ImportableQuestionType = Exclude<
  QuestionType,
  QuestionType.Overview | QuestionType.Section
>;

export type ImportedQuestionType = ImportableQuestionType | null;

export interface ParsedQuestion {
  id?: string;
  // quiz file usually have a question identifier.
  questionId: string;
  questionType: ImportableQuestionType | null;
  shuffle?: boolean;
  shortPrompt: string | null;
  prompt: string;
  promptImage?: PromptImage | null;
  fileOriginId: string;
  points?: number;
  fields: QuestionFieldInput[];
  feedback?: string;
  loading?: boolean;
  error?: Error;
}

export type SourceFile = {
  id?: string;
  /**
   * client side only id so that operations can be done
   * before data goes to server
   **/
  fileOriginId: string;
  filepath: string;
  filename?: string;
  loading?: boolean;
  error?: Error;
};

export type FileParsedQuestion = {
  questions: ParsedQuestion[];
  fileOrigin: SourceFile;
  tags?: string[];
};

export interface QuestionImportSlice {
  loading: boolean;
  processingFiles: number;
  processedFiles: number;
  importedQuestions: FileParsedQuestion[];
  allTags: string[];
}

export interface ImportedFileColumn {
  fileId: SourceFile["fileOriginId"];
  filename: SourceFile["filename"];
  filepath: SourceFile["filepath"];
  questions: ParsedQuestion[];
  status: ImportFileStatus;
}

export enum ImportFileStatus {
  PartialImport = "Partial Import",
  Success = "Success",
  FailedToImport = "Failed to Import",
}
